import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="relative bg-black text-white" data-id="element-106">
      {/* Sticky Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`} data-id="element-107">
        <div className="max-w-[1200px] mx-auto px-4 lg:px-8" data-id="element-108">
          <div className="flex h-16 lg:h-20 items-center justify-between" data-id="element-109">
            {/* Logo */}
            <div className="flex items-center gap-2 flex-shrink-0" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/hrXX85rhn4YR9sbdgFXsGs/beclinical.svg_(1).png" alt="Be Clinical" className="h-10 w-auto" data-id="element-111" />
            </div>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-112">
              <a href="#about" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-113">
                About Us
              </a>
              <a href="#treatments" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-114">
                Treatments
              </a>
              <a href="#financing" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-115">
                Financing
              </a>
              <a href="#testimonials" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-116">
                Testimonials
              </a>
              <a href="#specials" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-117">
                Specials
              </a>
              <a href="#membership" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-118">
                Membership
              </a>
              <a href="#blog" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-119">
                Blog
              </a>
              <Button variant="primary" size="sm" data-id="element-120">
                Book Consult
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button className="lg:hidden p-2 text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-121">
              {isMenuOpen ? <XIcon size={24} data-id="element-122" /> : <MenuIcon size={24} data-id="element-123" />}
            </button>
          </div>
        </div>

        {/* Mobile Full-Screen Overlay */}
        {isMenuOpen && <div className="lg:hidden fixed inset-0 z-50 bg-[#111111] overflow-y-auto flex flex-col items-center justify-center gap-8 p-8 pt-24" data-id="element-124">
            {/* Close Button */}
            <button onClick={() => setIsMenuOpen(false)} className="absolute top-6 right-6 p-2 text-white hover:text-[#FF1493] transition-colors" aria-label="Close menu" data-id="element-125">
              <XIcon size={28} data-id="element-126" />
            </button>

            <a href="#about" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-127">
              About Us
            </a>
            <a href="#treatments" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-128">
              Treatments
            </a>
            <a href="#financing" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-129">
              Financing
            </a>
            <a href="#testimonials" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-130">
              Testimonials
            </a>
            <a href="#specials" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-131">
              Specials
            </a>
            <a href="#membership" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-132">
              Membership
            </a>
            <a href="#blog" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-133">
              Blog
            </a>
            <Button variant="primary" size="lg" className="w-full max-w-xs mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-134">
              Book Consult
            </Button>
          </div>}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden" data-id="element-135">
        {/* Background Image - Right Half */}
        <div className="absolute inset-0 lg:left-[30%]" data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/cRanaaBKhru8S2y1FB84nK/Frame_239033.jpg" alt="Woman receiving beauty treatment with glowing skin, hands in black medical gloves framing her face" className="h-full w-full object-cover object-center" data-id="element-137" />
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" data-id="element-138"></div>
          <div className="absolute inset-0 bg-black/40 lg:bg-transparent" data-id="element-139"></div>
        </div>

        {/* Decorative Script Words */}
        <div className="absolute inset-0 hidden lg:block pointer-events-none z-10" data-id="element-140">
          <span className="font-script text-white/70 text-3xl xl:text-4xl absolute top-[22%] right-[18%] rotate-[-12deg]" data-id="element-141">
            Snatched
          </span>
          <span className="font-script text-white/60 text-3xl xl:text-4xl absolute top-[18%] right-[5%] rotate-[8deg]" data-id="element-142">
            Polished
          </span>
          <span className="font-script text-white/65 text-3xl xl:text-4xl absolute top-[45%] right-[3%] rotate-[-8deg]" data-id="element-143">
            Refined
          </span>
          <span className="font-script text-white/55 text-3xl xl:text-4xl absolute top-[70%] right-[10%] rotate-[5deg]" data-id="element-144">
            Flawless
          </span>
        </div>

        {/* Hero Content */}
        <div className="relative z-20 w-full max-w-[1200px] mx-auto px-6 lg:px-8 pt-28 pb-16 lg:pt-0 lg:pb-0" data-id="element-145">
          <div className="max-w-2xl" data-id="element-146">
            {/* Main Headline - BE EXCELLENT */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[80px] uppercase text-white tracking-tight mb-6 text-center font-[500] font-[Poppins,_sans-serif]" data-id="element-147">
              BE EXCELLENT
            </h1>

            {/* Diamond Shape */}
            <div className="flex justify-center mb-8 text-[160px] font-[500] font-[Poppins,_sans-serif] items-center" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/uu9vckamxznJfhWXHg2VLM/Vector_12_(1).png" alt="" className="h-auto" style={{
              width: '18px'
            }} data-id="element-149" />
            </div>

            {/* Subheadline - Italic Serif */}
            <h2 className="font-serif italic text-2xl sm:text-3xl md:text-4xl lg:text-[42px] text-white leading-[1.2] mb-8 text-center" data-id="element-150">
              Transforming Beauty,
              <br data-id="element-151" />
              Empowering Confidence
            </h2>

            {/* Quote */}
            <p className="italic text-base lg:text-lg mb-10 max-w-lg text-center leading-relaxed font-[Poppins,_sans-serif] font-[600] text-[#FFFFFF] mx-auto" data-id="element-152">
              "At Be CLINICAL, we combine the art of aesthetics with the science
              of medicine to unveil your true beauty."
            </p>

            {/* CTA */}
            <div className="flex justify-center items-center" data-id="element-153">
              <Button variant="primary" size="lg" className="w-full sm:w-auto min-h-[52px] px-10 text-sm tracking-widest" data-id="element-154">
                SCHEDULE CONSULTATION
              </Button>
            </div>
          </div>
        </div>
      </section>
    </header>;
}